var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-outer-wrapper"},[_c('div',{staticClass:"modal-inner-wrapper"},[_c('span',{staticClass:"close-modal is-clickable",on:{"click":_vm.close}},[_c('i',{staticClass:"fas fa-times"})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }